import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { Button } from "@/components/ui";
import { ChevronRight, ChevronDown, Plus } from "lucide-react";

import * as DTO from "../../../../interfaces";
import { useAccountSettings, URLS } from "../../../../utils";
import { PromptCard } from "../../../../components/Cells";
import { EditableField } from "../../../../components";

import { WebComponents } from "../../../../interfaces";

interface OwnProps {
  promptList: DTO.Prompt[];
  name: string;
  category?: DTO.Category;
  disable?: boolean;
  deliveryMode?: DTO.DeliveryMode;
  handleCategoryChange?: (categoryName: string) => void;
}

type Props = OwnProps & RouteComponentProps;

const CategorySectionFC: React.FC<Props> = ({
  category,
  promptList,
  name,
  disable = false,
  history,
  deliveryMode = "LIBRARY",
  handleCategoryChange,
}) => {
  const [display, setDisplay] = React.useState<boolean>(true);
  const promptsToShow = promptList;

  const { hasWritePermission } = useAccountSettings();
  const withWritePermission = hasWritePermission(WebComponents.PROMPTS);

  return (
    <div>
      <div className="flex items-center justify-between">
        <EditableField
          headerType="h2"
          currentValue={name}
          handleChangeValue={handleCategoryChange}
          disable={disable || !withWritePermission}
        />

        <div>
          <Button variant="ghost" size="xs" onClick={() => setDisplay(!display)}>
            {display ? "Collapse" : "Expand"} ({promptList.length})
            {display ? <ChevronRight className="ml-2" /> : <ChevronDown className="ml-2" />}
          </Button>
        </div>
      </div>

      <div className="flex gap-x-5">
        {withWritePermission && (
          <Button
            variant="outline"
            className="bg-background hover:bg-background rounded-2 my-2 border border-border border-dashed w-38 h-45 hover:shadow-md flex flex-col items-center justify-center"
            onClick={() => {
              history.push(URLS.coach.newPrompt, {
                deliveryMode,
                category,
              });
            }}
          >
            <Plus className="border rounded-full border-border size-7 p-1" />
            Add new
          </Button>
        )}

        <div className={"flex gap-x-5 " + (display ? "flex-wrap" : "overflow-auto h-fit")}>
          {promptsToShow.map(prompt => {
            return (
              <PromptCard
                key={"library_prompt_card_" + prompt.promptId}
                prompt={prompt}
                onClick={() => history.push(URLS.coach.prompt.replace(":promptId", prompt.promptId?.toString() ?? ""))}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export const CategorySection = withRouter(CategorySectionFC);
